import {
  Avatar,
  Box,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";

import bnb from "../../Components/images/bnb-logo.png";
import Header from "./Header";
import Footer from "../../Components/Footer";
import { Add } from "@mui/icons-material";
import Loading from "../../Components/Loading";
import { formatUnits, parseUnits } from "@ethersproject/units";
import { toast } from "react-toastify";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  useFarmingContract,
  useLPTokenContract,
} from "../../Connectivity/Hooks";
import { stakingLpContract as stakingAddress } from "../../Connectivity/environment";
import { AppContext } from "../../utils";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import logo from "../../Components/images/mainlogo.png";

const particleOptions = {
  autoPlay: true,
  background: {
    color: {
      value: "transparent",
      opacity: "0.2",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onHover: {
        enable: true,
        mode: "grab",
      },
    },
    modes: {
      grab: {
        distance: 200,
        links: {
          opacity: 0.8,
        },
      },
    },
  },
  particles: {
    number: {
      value: 200,
    },
    color: {
      value: "#a0c8f0",
    },
    shape: {
      type: "polygon",
      polygon: {
        sides: 15,
      },
    },
    move: {
      // Enable particle movement
      enable: true,
      // Set the speed of particles
      speed: 2,
      // Enable particles to bounce off the edges
      bounce: true,
    },

    size: {
      value: 1, // Decrease the value to decrease particle size
      random: true, // Enable random size variation
      anim: {
        enable: false, // Disable size animation
        speed: 0, // Set animation speed to 0 (disabled)
        size_min: 0, // Set minimum size during animation
      },
    },
  },
};

const FarmingUi = () => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState("");
  const [Balance, setBalance] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [claimed, setClaimed] = useState();
  const [totalStaked, setTotalStaked] = useState("");
  const [totalReward, setTotalReward] = useState("");
  const [loading, setLoading] = useState(false);
  const [stakeDetails, setstakeDetails] = useState([]);
  const [index, setIndex] = useState(0);

  // eslint-disable-next-line no-unused-vars
  const [duration, setDuration] = useState("");
  const [satkedIndex, setStakedIndex] = useState(0);
  const [planIndex, setPlanIndex] = useState([]);

  const currentDate = moment();
  const newDate = currentDate.add(
    // eslint-disable-next-line eqeqeq
    index == 0
      ? planIndex[0]?.poolDuration
      : // eslint-disable-next-line eqeqeq
      index == 1
      ? planIndex[1]?.poolDuration
      : // eslint-disable-next-line eqeqeq
      index == 2
      ? planIndex[2]?.poolDuration
      : planIndex[3]?.poolDuration,
    "seconds"
  );

  const matches = useMediaQuery("(max-width:750px)");

  const { account, connect, signer, gasEstimationForAll } =
    useContext(AppContext);

  const stakingContract = useFarmingContract(signer);
  const stakingContract1 = useFarmingContract();
  const tokenContract = useLPTokenContract(signer);
  const tokenContract1 = useLPTokenContract();

  // eslint-disable-next-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const init = useCallback(async () => {
    try {
      const totalReward = await stakingContract1.totalDistributedReward();
      setTotalReward(+totalReward);
      const duration = await stakingContract1.duration();
      setDuration(duration.toString());
    } catch (error) {
      console.log(error);
    }
  });
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, totalStaked, index]);

  // console.log(totalReward, "reward");

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const calculateReward = async () => {
    try {
      const claimReward = await stakingContract.calculateReward(
        account,
        Number(satkedIndex)
      );

      return claimReward;
    } catch (error) {
      return 0;
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const inits = useCallback(async () => {
    try {
      const decimals = await tokenContract1.decimals();
      const balance = await tokenContract.balanceOf(account);

      const { _stakeCount, _totalStaked } = await stakingContract.getUserInfo(
        account.toString()
      );

      setBalance(formatUnits(balance.toString(), decimals));
      setTotalStaked(formatUnits(_totalStaked.toString(), decimals));
      const claimReward = await calculateReward();
      let claimreward = claimReward;

      if (+_stakeCount > 0) {
        let arr = [];
        for (let i = 0; i < +_stakeCount; i++) {
          const { _lpAmount, _startTime, _reward, _isWithdrawn, _endTime } =
            await stakingContract.getUserStakeInfo(account, i.toString());
          const obj = {
            stakedLp: +formatUnits(_lpAmount.toString(), decimals),
            startTime: +_startTime,
            reward: parseFloat(
              +formatUnits(_reward.toString(), decimals)
            ).toFixed(7),
            _isWithdrawn: _isWithdrawn,
            claimReward: claimreward === undefined ? 0 : claimReward,
            endTime: +_endTime,
          };
          setStakedIndex(i);

          setClaimed(+formatUnits(_reward.toString(), decimals));
          arr.push(obj);
        }

        setstakeDetails([...arr]);
      }
    } catch (error) {
      console.log(error.message, "inits erros");
      setLoading(false);
    }
  });

  useEffect(() => {
    inits();
    // eslint-disable-next-line react-hooks/exhaustive-deps, no-sparse-arrays
  }, [account, Balance, totalStaked, claimed, stakeDetails]);

  useEffect(() => {
    const durationData = async () => {
      let arr = [];
      for (let i = 0; i < 4; i++) {
        const { _poolDuration, _rewardMultiplier } =
          await stakingContract.getPoolInfo(i);

        let obj = {
          poolDuration: +_poolDuration,
          rewardMultiplier: _rewardMultiplier.toString().slice(0, -2),
        };
        arr.push(obj);
      }
      setPlanIndex(arr);
    };
    durationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  const stakeHandler = async () => {
    const decimals = await tokenContract1.decimals();
    if (!account) {
      toast.error("Error! Please connect your wallet.");
    } else if (!amount) {
      toast.error("Error! Please enter a amount");
    } else if (amount <= 0) {
      toast.error("Error! Enter valid amount");
    } else {
      try {
        setLoading(true);

        let decimalAllownce = decimals + 2;

        let allowance = await tokenContract.allowance(account, stakingAddress);

        const Allowance = formatUnits(allowance.toString(), decimalAllownce);

        if (Allowance < amount) {
          let getAmounts = Balance;
          const data1 = [
            stakingAddress,
            parseUnits(getAmounts.toString(), decimalAllownce),
          ];
          const fn1 = tokenContract.estimateGas.approve;
          const tx = await tokenContract.approve(
            stakingAddress,
            parseUnits(getAmounts.toString(), decimals),
            {
              gasLimit: gasEstimationForAll(account, fn1, data1),
            }
          );

          await tx.wait();

          toast.success("Success! Approved Confirmed.");
        }

        const fn = stakingContract.estimateGas.stake;

        const data = [
          parseUnits(amount.toString(), decimals),
          index.toString(),
        ];

        const tx1 = await stakingContract.stake(
          parseUnits(amount.toString(), decimals),
          index.toString(),
          {
            gasLimit: gasEstimationForAll(account, fn, data),
          }
        );
        setAmount("");
        await tx1.wait();
        toast.success("Success! Transaction Confirmed.");
        setLoading(false);
        init();
        inits();
      } catch (err) {
        if (err?.data?.message) {
          toast.error(err?.data?.message);
        } else if (err?.reason) {
          toast.error(err?.reason);
        } else {
          toast.error(err?.message);
        }
        setLoading(false);
      }
    }
  };

  const harvestHandler = async (index) => {
    try {
      setLoading(true);
      const fn = stakingContract.estimateGas.harvest;
      const data = [index.toString()];

      const tx = await stakingContract.harvest(index.toString(), {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      toast.success("Success!  successfully  harvested .");
      inits();
      init();
      setLoading(false);
    } catch (err) {
      if (err?.data?.message) {
        toast.error(err?.data?.message);
      } else if (err?.reason) {
        toast.error(err?.reason);
      } else {
        toast.error(err?.message);
      }
      setLoading(false);
    }
  };

  const WithdrwaHandler = async (index) => {
    try {
      setLoading(true);

      const fn = stakingContract.estimateGas.withdraw;
      const data = [index.toString()];

      const tx = await stakingContract.withdraw(index.toString(), {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      toast.success("Success! Amount successfully claimed.");
      inits();
      init();

      setLoading(false);
    } catch (err) {
      if (err?.data?.message) {
        toast.error(err?.data?.message);
      } else if (err?.reason) {
        toast.error(err?.reason);
      } else {
        toast.error(err?.message);
      }
      setLoading(false);
    }
  };

  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log(container);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: "#000",

        color: "#fff",
        height: "auto",
        pb: 4,
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particleOptions}
      />
      <Box>
        <Header />
        <Container maxWidth="md">
          <Box py={5}>
            <Typography
              sx={{
                fontSize: { xs: "20px", md: "36px" },
                fontWeight: "400",
                fontFamily: "Poppins",
                color: "#ff",
                textAlign: "center",
                mb: 2,
              }}
            >
              Farm
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "15px", md: "25px" },
                fontWeight: "300",
                fontFamily: "Poppins",
                color: "grey",
                textAlign: "center",
                mb: 2,
              }}
            >
              LP Token Staking DSage/BNB
            </Typography>
            <Box display={"flec"} justifyContent={"center"}>
              <Avatar src={logo} sx={{ width: "80px", height: "80px" }} />
              <Avatar
                src={bnb}
                sx={{ width: "65px", height: "65px", ml: -3, mt: 1 }}
              />
            </Box>
          </Box>

          {/* calculator ------------------------------------- */}

          <Box
            sx={{
              marginTop: "2rem",
              bgcolor: "#000",
              backdropFilter: "blur(5px)",
              opacity: 0.7,
              color: "#fff",
              py: { md: 2, xs: 1 },
              padding: { md: "2rem", xs: "1rem" },
              textAlign: "center",
              borderRadius: "20px",
              boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
            }}
            mb={4}
          >
            <Loading loading={loading} />

            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                fontSize: { md: "16px", xs: "14px" },
                fontWeight: "400",
                color: "#fff",
              }}
            >
              {t("Farming.des")}
            </Typography>

            <Box
              mt={2}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: { sm: "row", xs: "column" },
                gap: { md: 10, xs: 2 },
              }}
            >
              <Typography
                varaint="h3"
                sx={{
                  fontSize: { md: "20px", xs: "18px" },
                  fontWeight: "500",

                  fontFamily: "Poppins",
                  color: "#fff",
                  textAlign: "left !important",
                  marginLeft: { md: "-10rem", xs: "1rem" },
                }}
              >
                Lp Token
              </Typography>

              <TextField
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                type="number"
                sx={{ width: { xs: "100%", sm: "70%", md: "30%" } }}
                placeholder="Enter amount"
                InputProps={{
                  sx: {
                    background: "transparent",
                    border: "1px solid #fff",
                    boxShadow:
                      "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
                    color: "#fff",

                    //   ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    //     border: "none",
                    //     color: "black",
                    //   },

                    "&.MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                        outline: "none",
                      },
                    },
                  },
                }}
              />
            </Box>
            <Add
              style={{
                textAlign: "center",
                margin: "0.5rem 0",
                color: "#fff",
                fontWeight: "400",
                fontSize: "35px",
              }}
            />
            <Typography
              variant="h6"
              mb={3}
              sx={{
                fontSize: "15px",
                fontWeight: "400",
                fontFamily: "Poppins",
                color: "#fff",
                textAlign: "center",
              }}
            >
              {t("Farming.des1")}
            </Typography>

            <Box
              display="flex"
              justifyContent="space-around"
              flexWrap="wrap"
              gap={2}
            >
              <Button
                sx={{
                  my: 2,
                  color: "#fff",
                  borderRadius: "50px",
                  padding: "0.5rem 1.5rem",
                  textTransform: "none",
                  display: "block",
                  fontSize: "15px",
                  fontWeight: index === 0 ? "500" : "400",
                  background: "#CB3C35",
                  "&:hover": {
                    background: "#CB3C35",
                  },
                  width: "160px",
                  border: index !== 0 ? "none" : "1px solid #fff",
                  fontFamily: "Poppins",
                }}
                onClick={() => setIndex(0)}
              >
                {/* Flexible      - 10% */} {t("FarmingUi.head7")} -{" "}
                {planIndex[0]?.rewardMultiplier}%
              </Button>
              <Button
                sx={{
                  my: 2,
                  color: "#fff",

                  borderRadius: "50px",

                  padding: "0.5rem 1.5rem",
                  textTransform: "none",
                  display: "block",
                  fontSize: "15px",
                  fontWeight: index === 1 ? "500" : "400",

                  background: "#CB3C35",
                  "&:hover": {
                    background: "#CB3C35",
                  },
                  width: "160px",

                  border: index !== 1 ? "none" : "1px solid #fff",

                  fontFamily: "Poppins",
                }}
                onClick={() => setIndex(1)}
              >
                {moment
                  .duration(planIndex[1]?.poolDuration, "seconds")
                  .asMonths()
                  .toFixed(0)}
                {t("FarmingUi.head8")} - {planIndex[1]?.rewardMultiplier}%
              </Button>
              <Button
                sx={{
                  my: 2,
                  color: "#fff",
                  borderRadius: "50px",

                  padding: "0.5rem 1.5rem",
                  textTransform: "none",
                  display: "block",
                  fontSize: "15px",
                  fontWeight: index === 2 ? "500" : "400",

                  background: "#CB3C35",
                  "&:hover": {
                    background: "#CB3C35",
                  },
                  width: "160px",

                  border: index !== 2 ? "none" : "1px solid #fff",

                  fontFamily: "Poppins",
                }}
                onClick={() => setIndex(2)}
              >
                {moment
                  .duration(planIndex[2]?.poolDuration, "seconds")
                  .asMonths()
                  .toFixed(0)}
                {t("FarmingUi.head8")} -{planIndex[2]?.rewardMultiplier}%
              </Button>
              <Button
                sx={{
                  my: 2,
                  color: "#fff",
                  borderRadius: "50px",

                  padding: "0.5rem 1.5rem",
                  textTransform: "none",
                  display: "block",
                  fontSize: "15px",
                  fontWeight: index === 3 ? "500" : "400",

                  background: "#CB3C35",
                  "&:hover": {
                    background: "#CB3C35",
                  },
                  width: "160px",

                  border: index !== 3 ? "none" : "1px solid #fff",

                  fontFamily: "Poppins",
                }}
                onClick={() => setIndex(3)}
              >
                {moment
                  .duration(planIndex[3]?.poolDuration, "seconds")
                  .asMonths()
                  .toFixed(0)}
                {t("FarmingUi.head8")} - {planIndex[3]?.rewardMultiplier}%
              </Button>
            </Box>

            <Box py={4}>
              <Typography
                sx={{
                  marginTop: "1rem",
                  fontSize: "15px",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                {index === 0
                  ? "flexible"
                  : `${t("FarmingUi.head9")} ${newDate.format("DD-MM-YYYY")}`}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" mt={3}>
              {account ? (
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                  //   disabled={stakeDetails.length > 0 ? true : false}
                  onClick={() => stakeHandler()}
                >
                  {/* Stake */} {t("StakingUi.phead9")}
                </Button>
              ) : (
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                  onClick={() => connect()}
                >
                  {/* Connect Wallet */} {t("StakingUi.phead10")}
                </Button>
              )}
            </Box>
          </Box>

          {/* plege ------------------------------------ */}

          <Box
            mt={10}
            py={5}
            borderRadius="20px"
            sx={{
              boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
              bgcolor: "#000",
              backdropFilter: "blur(5px)",
              opacity: 0.7,
            }}
            px={{ md: 5, xs: 3 }}
            height="100%"
          >
            <Box display="flex" gap={1} alignItems="center">
              <Box width="7px" height="30px" bgcolor="#CB3C35"></Box>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "25px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {t("Farming.des3")}
              </Typography>
            </Box>

            <Box display="flex" justifyContent={"space-between"} mt={2}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {/* Your Wallect Balance */}
                {t("FarmingUi.head10")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {Balance ? Balance : 0}
              </Typography>
            </Box>

            <Box display="flex" justifyContent={"space-between"} mt={2}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {/* Claim Reward
                 */}
                {t("FarmingUi.head11")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {totalReward ? totalReward : 0}
              </Typography>
            </Box>

            <Box display="flex" justifyContent={"space-between"} mt={2}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {/* Total Staked */}
                {t("FarmingUi.head12")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {totalStaked ? totalStaked : 0}
              </Typography>
            </Box>
          </Box>

          {/* ----------------Table */}

          <Box
            mt={10}
            py={5}
            borderRadius="20px"
            sx={{
              boxShadow:
                " rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
              backgroundColor: "#000",
              backdropFilter: "blur(5px)",
              opacity: 0.7,
              // display: "flex",
              // justifyContent: "center",
              // alignItems: "center",
            }}
            px={{ md: 5, xs: 2 }}
            height="100%"
          >
            <Box display="flex" gap={1} alignItems="center">
              <Box width="7px" height="30px" bgcolor="#CB3C35"></Box>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "25px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                Defi Sage
              </Typography>
            </Box>

            <Box>
              <TableContainer
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "transparent",

                  backgroundClip: "content-box, border-box",
                  padding: "4px",
                }}
                filter="blur(52px)"
                zIndex="10"
                pt={2}
                pb={5}
                mt={2}
                className="shadow"
                // borderRadius="20px"
                component={Box}
                color="#fff"
              >
                <Table
                  id="my-table"
                  aria-label="simple table"
                  style={{
                    borderRadius: "10px",
                    marginTop: "0px",
                  }}
                  color="#fff"
                >
                  <TableHead color="#000">
                    <TableRow style={{ color: "#fff" }}>
                      <TableCell
                        align="center"
                        style={{
                          color: "#fff",
                          fontSize: matches ? "12px" : "18px",
                          fontFamily: "Poppins",
                        }}
                      >
                        {/* AMOUNT */}
                        {t("FarmingUi.head13")}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color: "#fff",
                          fontSize: matches ? "12px" : "18px",
                          fontFamily: "Poppins",
                        }}
                      >
                        {/* WITHDRAW TIME
                         */}

                        {t("FarmingUi.head18")}
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          color: "#fff",
                          fontSize: matches ? "12px" : "18px",
                          fontFamily: "Poppins",
                        }}
                        width={"100px"}
                      >
                        {/* Reward */}
                        {/* Claimable Reward */}
                        {t("FarmingUi.head19")}
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          color: "#fff",
                          fontSize: matches ? "12px" : "18px",
                          fontFamily: "Poppins",
                        }}
                      >
                        {/* Harvest */}
                        {t("FarmingUi.head15")}
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          color: "#fff",
                          fontSize: matches ? "12px" : "18px",
                          fontFamily: "Poppins",
                        }}
                      >
                        {/* WITHDRAW */}
                        {t("FarmingUi.head16")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stakeDetails.length > 0 ? (
                      stakeDetails.map(
                        (
                          {
                            startTime,
                            stakedLp,
                            _isWithdrawn,
                            claimReward,
                            endTime,
                          },
                          index
                        ) => {
                          return (
                            <TableRow
                              key={index}
                              style={{ borderBottom: "1px solid red" }}
                            >
                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                  fontSize: matches ? "14px" : "18px",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {stakedLp}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                  fontSize: matches ? "14px" : "18px",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {moment.unix(startTime).format("LLL")}
                              </TableCell>

                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                  fontSize: matches ? "14px" : "18px",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {claimReward.toString()
                                  ? claimReward.toString()
                                  : 0}
                              </TableCell>

                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                }}
                              >
                                <Box display="flex" justifyContent="center">
                                  <Button
                                    onClick={() =>
                                      harvestHandler(index.toString())
                                    }
                                    disabled={
                                      moment(startTime * 1000)
                                        .add(1, "d")
                                        .valueOf() > moment().valueOf()
                                        ? true
                                        : false
                                    }
                                    sx={{
                                      color: "white",
                                      backgroundColor: "#CB3C35",
                                      border: "2px solid gray",
                                      borderRadius: "10px",
                                      padding: "0.5rem 1rem",
                                      textTransform: "none",
                                      "&:hover": {
                                        backgroundColor: "#CB3C35",
                                      },
                                    }}
                                  >
                                    harvest
                                  </Button>
                                </Box>
                              </TableCell>

                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                }}
                              >
                                <Box display="flex" justifyContent="center">
                                  <Button
                                    onClick={() =>
                                      WithdrwaHandler(index.toString())
                                    }
                                    disabled={
                                      _isWithdrawn === true
                                        ? true
                                        : false ||
                                          moment(endTime) > moment(startTime)
                                        ? true
                                        : false
                                    }
                                    sx={{
                                      color: "white",
                                      backgroundColor: "#CB3C35",
                                      border: "2px solid gray",
                                      borderRadius: "10px",
                                      padding: "0.5rem 1rem",
                                      textTransform: "none",
                                      "&:hover": {
                                        backgroundColor: "#CB3C35",
                                      },
                                    }}
                                  >
                                    Withdraw
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )
                    ) : loading ? (
                      loading
                    ) : (
                      <TableRow>
                        <TableCell
                          align="center"
                          style={{
                            color: "#fff",
                            fontSize: matches ? "14px" : "18px",
                            fontFamily: "Poppins",
                          }}
                          colSpan={5}
                        >
                          {t("Farming.des2")}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Container>
        <Footer />
      </Box>
    </Box>
  );
};

export default FarmingUi;
